
import Vue from "vue";
import $ from "jquery";
import Component from "vue-class-component";
import { State } from "vuex-class";
import { Prop } from "vue-property-decorator";
import AppNavbarSecondary1 from "@/components/layout/AppNavbarSecondary1.vue";
import AppNavbarSecondary2 from "@/components/layout/AppNavbarSecondary2.vue";
import AppNavbarSecondary3 from "@/components/layout/AppNavbarSecondary3.vue";
import AppNavbarSecondary4 from "@/components/layout/AppNavbarSecondary4.vue";
@Component({
  components: {
    AppNavbarSecondary4,
    AppNavbarSecondary3,
    AppNavbarSecondary2,
    AppNavbarSecondary1,
  },
})
export default class AppNavbarSecondary extends Vue {
  @State("school", { namespace: "school" })
  private school!: any;
  @State("template", { namespace: "school" })
  private template!: any;

  @Prop({ default: 1 })
  private templateNumber!: number;

  private mobileMenu = false;

  private created() {
    $(document).ready(function () {
      $(window).scroll(function () {
        let scroll = $(window).scrollTop() as number;
        if (scroll >= 30) {
          $(".nav-container").addClass("bg-white");
          $("#nav-brand-name").removeClass("text-white");
        } else {
          $(".nav-container").removeClass("bg-white");
          $("#nav-brand-name").addClass("text-white");
        }
      });
    });
  }

  private goHome() {
    if (this.$route.name !== "landing") this.$router.push({ name: "landing" });
  }
}
